/**
 * @author Jorge Casas
 * @creationDate 12/07/2024
 */

/**
 * This function formats a date into a string with the local format.
 *
 * @description Function to format a date in UTC format
 *
 * @param {String} dateString
 * @returns {String} date formatted
 * @throws {Error} if an error occurs
 *
 * Example:
 * formatDateUTC("2024-03-15T00:00:00.000Z");
 * Expected output: 05 abr 2024,12:00:00 a. m.
 */
export const formatDateUTCWithTime = (dateString) => {
  try {
    const date = new Date(dateString);
    const options = {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    };
    return date.toLocaleString('es-MX', options);
  } catch (error) {
    console.log('🚀 ~ file: format-date.js:27 ~ formatDateUTCWithTime ~ error:', error);
  }
};

/**
 * This function formats a date into a string with the local format.
 *
 * @param {number} amount - The number to be formatted.
 * @returns {string} - The formatted number.
 * @throws {Error} - If the amount is not a number.
 *
 * Example:
 * formatDateLocal("2024-03-15T00:00:00.000Z");
 * Expected output: 05 abr 2024
 */
export const formatDateLocalMexico = (dateString) => {
  try {
    const date = new Date(dateString);
    const options = {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    };
    return date.toLocaleString('es-MX', options);
  } catch (error) {
    console.log('🚀 ~ file: format-date.js:58 ~ formatDateLocalMexico ~ error:', error);
  }
};



// WEBPACK FOOTER //
// src/utils/additional-functions/format-date.js